/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_06_Detail_Amateur_1_HeadingInputs */

const en_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Understanding the Dissipation of Force`)
};

const es_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entender la disipación de la fuerza`)
};

const de_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Zerstreuung von Kraft verstehen`)
};

const zh_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`理解力量消散`)
};

const ar_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`فهم تبديد القوة`)
};

const fr_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprendre la dissipation de la force`)
};

const vi_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hiểu tiêu tán lực`)
};

const sw_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuelewa utawanyaji wa nguvu`)
};

const th_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ทำความเข้าใจการกระจายแรง`)
};

const bs_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razumijevanje disipacije sile`)
};

const ja_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`力の分散を理解する`)
};

const ko_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`힘의 방산 이해`)
};

const pt_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entender a dissipação da força`)
};

const it_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprensione delle forze dell'ordine`)
};

const sv_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Förstå kraftfördelning`)
};

const nl_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het begrijpen van de dissipatie van de macht`)
};

const da_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hvad kraftfordeling betyder`)
};

const nb_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Forståelse av forsvar`)
};

const fi_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voimanmenetyksen ymmärtäminen`)
};

const pl_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrozumienie rozproszenia sił`)
};

const ru_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Понимание рассеивания силы`)
};

const tr_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kuvvetin Dağıtılması Kavramını Anlamak`)
};

const hi_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सेना के विघटन को समझना`)
};

const id_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memahami Konsep Penyebaran Gaya`)
};

const ms_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Memahami Konsep Penyebaran Daya`)
};

const cs_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pochopení šíření síly`)
};

const el_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Κατανόηση της Διάδοσης της Δύναμης`)
};

const he_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`להבין את ההתנתקות של הכוח`)
};

const af_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Om die verspreiding van krag te verstaan`)
};

const hu_method_content_step_06_detail_amateur_1_heading = /** @type {(inputs: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az erőelvezetés megértése`)
};

/**
* | output |
* | --- |
* | "Understanding the Dissipation of Force" |
*
* @param {Method_Content_Step_06_Detail_Amateur_1_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_06_detail_amateur_1_heading = /** @type {((inputs?: Method_Content_Step_06_Detail_Amateur_1_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_06_Detail_Amateur_1_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "de") return de_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "zh") return zh_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "ar") return ar_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "fr") return fr_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "vi") return vi_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "sw") return sw_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "th") return th_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "bs") return bs_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "ja") return ja_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "ko") return ko_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "pt") return pt_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "it") return it_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "sv") return sv_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "nl") return nl_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "da") return da_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "nb") return nb_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "fi") return fi_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "pl") return pl_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "ru") return ru_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "tr") return tr_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "hi") return hi_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "id") return id_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "ms") return ms_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "cs") return cs_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "el") return el_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "he") return he_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "af") return af_method_content_step_06_detail_amateur_1_heading(inputs)
	if (locale === "hu") return hu_method_content_step_06_detail_amateur_1_heading(inputs)
	return en_method_content_step_06_detail_amateur_1_heading(inputs)
});